import APIs from "../../apiUrl";

const getUserBlogger = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_enduser_blog/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleBlogger = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_post/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const BloggersServices = {
  getUserBlogger,
  getSingleBlogger
};

export default BloggersServices;
